import { Component, OnInit, OnDestroy } from '@angular/core';
import { NgRedux } from '@angular-redux/store';
import { combineLatest } from 'rxjs/observable/combineLatest';
import { Subscription } from 'rxjs/Subscription';

import { IAppState } from '../../../app-states/store/IAppState';
import { Lab } from '../../../contracts/lab/lab.model';
import { AppUser } from '../../security/model';
import { ServerNotificationService } from '../../server-notification/server-notification.service';
import { NotificationMessage } from '../../server-notification/service-notification.interfaces';
import { NotificationProgressInfo } from '../../server-notification/progress-notification.interfaces';
import { ProgressAction } from '../../../app-states/modules/progress/progress.action';

const labStateSelector = (state: IAppState): Lab => state.labState.currentLab;
const userStateSelector = (state: IAppState): AppUser => state.sessionState.currentUser;

@Component({
  selector: 'mc-lab-listener',
  template: ``,
  styles: []
})
export class LabListenerComponent implements OnInit, OnDestroy {
  private serverNotificationSubscription: Subscription = null;

  constructor(private serverNotification: ServerNotificationService,
    private ngRedux: NgRedux<IAppState>,
    private progressAction: ProgressAction
  ) { }

  ngOnInit() {
    combineLatest(
      this.ngRedux.select(labStateSelector),
      this.ngRedux.select(userStateSelector),
      (labState, currentUser) => {
        if (labState && currentUser) {
          this.unSubscribeFromServerChanges();
          this.subscribeToServerChanges(labState, currentUser);
        }
      }
    ).toPromise();
  }

  ngOnDestroy() {
    if (this.serverNotificationSubscription) {
      this.serverNotificationSubscription.unsubscribe();
    }

    // For live testing purposes.
    if (window['enablemclog']) {
      // console.log('LabListenerComponent destroyed');
    }
  }

  subscribeToServerChanges(selectedLab: Lab, currentUser: AppUser) {
    // console.log('subscribeToServerChanges', selectedLab);
    const serverChanges = this.serverNotification.listen(selectedLab.id.toString() + currentUser.email.toLowerCase());
    this.serverNotificationSubscription = serverChanges.subscribe(
      (message: NotificationMessage) => {
        if (window['enablemclog']) {
          // console.log('Server Message', message);
        }

        const progress = message.payload as NotificationProgressInfo;

        if (message.name === 'Calculation_Progress_Update') {
          this.progressAction.calculationProgressReceived(progress);
        }
        else if (message.name === 'ImportData_Progress_Update') {
          this.progressAction.importDataProgressReceived(progress, true);
        }
        else if (message.name === 'ImportInstruments_Progress_Update') {
          this.progressAction.importDataProgressReceived(progress, false);
        }
      },
      (error: any) => {
        console.warn('Attempt to join group failed!', error);
      }
    );
  }

  // This is to make sure we don't subscribe multiple time to the server notifications
  unSubscribeFromServerChanges() {
    if (this.serverNotificationSubscription) {
      this.serverNotificationSubscription.unsubscribe();
      this.serverNotificationSubscription = null;
    }
  }
}



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/core/server-listeners/lab-listener/lab-listener.component.ts